import {computed, inject, Injectable, signal} from '@angular/core';
import {IGeneralError} from '../models/error.model';
import {LoadingService} from '@shared/services/loading.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorService {
	private loadingService = inject(LoadingService);
	private generalErrorSignal = signal<IGeneralError>({show: false, action: null});
	public generalError = computed(() => this.generalErrorSignal());


	constructor() {
	}

	public hideGeneralError(): void {
		this.generalErrorSignal.set({show: false, action: null});
	}

	public showGeneralError(action?: () => void): void {
		this.loadingService.hide();
		this.generalErrorSignal.set({show: true, action: action});
	}
}
